import FavoriteType from "../enums/favoriteType";

/**
 * getListingInformationForPaidSpec: Gets all the listing information that will be used to add a new Pending Save value.
 * @param {Object} dataset All the information related to the Paid Spec Card.
 * @returns An object with the required listing information for Paid Spec Listings for the new Pending Save value.
 */
function getListingInformationForPaidSpec(dataset) {
  const {
    specId, marketId, marketName, builderId, brandName, communityName, communityId, imageUrl,
    price, city, stateAbbreviation, zip, homeStatus, isBasic
  } = dataset;

  return {
    marketId,
    marketName,
    builderId,
    brandName,
    communityId,
    communityName,
    imageUrl,
    isBasic,
    homeStatus,
    price,
    id: specId,
    city,
    stateAbbreviation,
    zip,
  };
}

/**
 * getListingInformationForPaidCommunity: Gets all the listing information that will be used to add a
 * new Pending Save value.
 * @param {Object} dataset All the information related to the Paid Community Card.
 * @returns An object with the required listing information for Paid Community Listings for the new Pending Save value.
 */
function getListingInformationForPaidCommunity(dataset) {
  const {
    id, marketId, marketName, builderId, brandName, communityName, marketingStatusLabel, isBasic, imageUrl,
    priceHigh, priceLow, city, stateAbbreviation, zip
  } = dataset;

  return {
    id,
    marketId,
    marketName,
    builderId,
    brandName,
    name: communityName,
    marketingStatusLabel,
    isBasic,
    imageUrl,
    priceHigh,
    priceLow,
    city,
    stateAbbreviation,
    zip
  };
}

/**
 * getListingInformationForPaidPlan: Gets all the listing information that will be used to add a new Pending Save value.
 * @param {Object} dataset All the information related to the Paid Plan Card.
 * @returns An object with the required listing information for Paid Plan Listings for the new Pending Save value.
 */
function getListingInformationForPaidPlan(dataset) {
  const {
    planId, marketId, marketName, builderId, brandName, communityName, communityId, imageUrl,
    price, city, stateAbbreviation, zip, homeStatus, isBasic
  } = dataset;

  return {
    marketId,
    marketName,
    builderId,
    brandName,
    communityId,
    communityName,
    imageUrl,
    isBasic,
    homeStatus,
    price,
    id: planId,
    city,
    stateAbbreviation,
    zip,
  };
}

const listingInformationGetter = new Map();

listingInformationGetter.set(FavoriteType.Community, getListingInformationForPaidCommunity);
listingInformationGetter.set(FavoriteType.Spec, getListingInformationForPaidSpec);
listingInformationGetter.set(FavoriteType.Plan, getListingInformationForPaidPlan);

export default function getListingInformationFromDataset(dataset) {
  const listingType = FavoriteType.fromKey(dataset.type);
  const getListingInformation = listingInformationGetter.get(listingType);

  if (!getListingInformation) {
    return {}
  }

  return getListingInformation(dataset);
}